import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  useCheckinMutation,
  useGetCheckinDetailQuery,
} from "../redux/api/DashboardApi";
import toast, { Toaster } from "react-hot-toast";
import logo from "../img/crmlogo.png";
import avatar from "../img/random.jpeg";
import axios from "axios";
import { baseUrl } from "../constant";
import CheckoutModal from "./CheckoutModal";
const Navbar = ({
  setShowLogout,
  setSideAddClass,
  setAddClass,
  addClass,
  addSideClass,
  
}) => {
  const [showModal, setShowMoadal] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isCheckin, setIsCheckin] = useState(false);
  const [checkinData, setCheckinData] = useState("");
  const [time, setTime] = useState(null);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [userName, setUserName] = useState("");
  const [userProfile, setUserProfile] = useState("");
  const [mobile, setMobile] = useState("");
  const userToken = localStorage.getItem("userToken");
  let id = userData?.data?.user_id;
  const handleDropdown = () => {
    if (showDropdown === false) return setShowDropdown(true);
    else return setShowDropdown(false);
  };

  const [postCheckin] = useCheckinMutation();
  const getCurrentDate = () => {
    const currentDate = new Date();
    return currentDate.toISOString().split("T")[0];
  };
  const date = new Date().toISOString().split("T")[0];
  const checkinDetails = useGetCheckinDetailQuery({
    id: id,
    date: date,
  });

  async function reverseGeocode(latitude, longitude) {
    const apiKey = "AIzaSyD2mbxXISLWkdRVrm12QkliQYvAHurBrsk";
    const response = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
    );
    const data = await response.json();

    const address =
      data.results[0]?.formatted_address || "Address not available";
    // console.log(data.results[0]?.formatted_address);

    return address;
  }
  const options = {
    timeZone: "Asia/Kolkata", // Set to Indian Standard Time
    hour12: true, // Use 12-hour format
    hour: "2-digit",
    minute: "2-digit",
  };

  const handleCheckin = () => {
    try {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const user_id = userData?.data?.user_id;
            const currentTime = new Date();
            const checkinTime = currentTime.toLocaleString("en-US", options);
            const address = await reverseGeocode(latitude, longitude);
            try {
              const checkinDetails = {
                userid: user_id,
                checkinOutdate: getCurrentDate(),
                checkintime: checkinTime,
                checkouttime: "",
                address: address,
              };
              // console.log(checkinDetails);
              postCheckin(checkinDetails)
                .then((res) => {
                  if (res?.data?.data?.is_login === 1) {
                    setIsCheckin(true);
                    setTime(checkinTime);
                    localStorage.setItem("isCheckedin", checkinTime);
                    // console.log(res);
                  } else if (res?.data?.key === "Already Done") {
                    toast.error("Already Done");
                  } else {
                    // console.log("Somwthing went wrong");
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } catch (error) {
              console.error("Error during check-in:", error.message);
            }
          },
          (error) => {
            if (error.code === 1) {
              alert("Please allow location access to check in.");
            } else {
              console.error("Error getting location:", error.message);
            }
          }
        );
      } else {
        alert("Geolocation is not available in your browser.");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const handleCheckOut = () => {
    try {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const user_id = userData?.data?.user_id;
            const currentTime = new Date();
            const checkoutTime = currentTime.toLocaleString("en-US", options);
            const address = await reverseGeocode(latitude, longitude);
            try {
              const checkinDetails = {
                userid: user_id,
                checkinOutdate: getCurrentDate(),
                checkintime: "",
                checkouttime: checkoutTime,
                address: address,
              };

              postCheckin(checkinDetails)
                .then((res) => {
                  if (res?.data?.data?.is_login === 0) {
                    setIsCheckin(false);
                    setTime(null);
                    localStorage.removeItem("isCheckedin");
                    setShowMoadal(false)
                    // console.log(res);
                  } else {
                    // alert("Done")
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } catch (error) {
              console.error("Error during check-in:", error.message);
            }
          },
          (error) => {
            if (error.code === 1) {
              alert("Please allow location access to check out.");
            } else {
              console.error("Error getting location:", error.message);
            }
          }
        );
      } else {
        alert("Geolocation is not available in your browser.");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  useEffect(() => {
    if (
      checkinDetails.isSuccess &&
      !checkinDetails.isError &&
      !checkinDetails.isLoading
    ) {
      // console.log(checkinDetails?.data?.data?.checkinOutdate);
      localStorage.setItem(
        "isCheckedin",
        checkinDetails?.data?.data?.checkintime
      );
      localStorage.setItem(
        "isCheckedDate",
        checkinDetails?.data?.data?.checkinOutdate
      );
      setCheckinData(checkinDetails?.data?.data?.checkintime);
    } else {
      // console.log("Something went wrong");
    }
    if (
      localStorage.getItem("isCheckedin") &&
      checkinDetails?.data?.data?.is_login === 1
    ) {
      setIsCheckin(true);
      setTime(checkinData);
    } else {
      setIsCheckin(false);
      setTime(null);
    }
  }, [checkinDetails, checkinData]);

  const handleAutoCheckout = async () => {
    try {
      if ("geolocation" in navigator) {
        navigator.geolocation.getCurrentPosition(
          async (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            const user_id = userData?.data?.user_id;
            const currentTime = new Date();
            currentTime.setDate(currentTime.getDate() - 1);
            currentTime.setHours(23, 59, 0, 0);
            const checkoutTime = currentTime.toLocaleString("en-IN", options);
            const address = await reverseGeocode(latitude, longitude);
            try {
              const checkinDetails = {
                userid: user_id,
                checkinOutdate: getCurrentDate(),
                checkintime: "",
                checkouttime: checkoutTime,
                address: address,
              };
              postCheckin(checkinDetails)
                .then((res) => {
                  if (res?.data?.data?.is_login === 0) {
                    setIsCheckin(false);
                    setTime(null);
                    localStorage.removeItem("isCheckedin");
                    // console.log(res);
                  } else {
                    // alert("Done")
                  }
                })
                .catch((error) => {
                  console.log(error);
                });
            } catch (error) {
              console.error("Error during check-in:", error.message);
            }
          },
          (error) => {
            if (error.code === 1) {
              alert("Please allow location access to check out.");
            } else {
              console.error("Error getting location:", error.message);
            }
          }
        );
      } else {
        alert("Geolocation is not available in your browser.");
      }
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  const checkDayChangeInterval = setInterval(() => {
    const currentTime = getCurrentDate();
    const storedCheckinDate = localStorage.getItem("isCheckedDate");
    if (currentTime !== storedCheckinDate) {
      handleAutoCheckout();
      clearInterval(checkDayChangeInterval);
    } else {
      console.log("Not checkout");
    }
  }, 4 * 60 * 60 * 1000);

  const handleSidebar = () => {
    if (addSideClass === "" || addClass === "") {
      setSideAddClass("sidebar-open");
      setAddClass("dahboard_context");
    } else {
      setSideAddClass("");
      setAddClass("");
    }
  };
 

  useEffect(() => {
    axios
      .get(`${baseUrl}profile`, {
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      })
      .then((res) => {
        setUserName(res?.data?.data?.name);
        setUserProfile(res?.data?.data?.profileimage);
        setMobile(res?.data?.data?.mobile);
      });
  }, [userToken]);

  const handleLogout = () => {
    setShowLogout(true)
    setShowDropdown(false)
  }

  return (
    <>
      <Toaster position="top-right" />
      <div className="click container d-flex  justify-content-between align-items-center z-1  position-relative ">
        <div className=" d-flex  align-items-center ">
          <Link to="/" className="">
            <img src={logo} alt="" style={{ width: "160px" }} />
          </Link>
          <Link
            className=" ms-3 fs-3 d-none d-lg-flex  d-xl-flex  d-md-flex"
            onClick={handleSidebar}
          >
            <i className="fa-solid fa-bars"></i>
          </Link>
        </div>
        <div className="d-flex justify-content-end align-items-center ">
          <div className="col-auto right-icon">
            {time && (
              <span className="me-1 time-show text-uppercase text-black">
                {time}
              </span>
            )}
            {!isCheckin ? (
              <button
                className="btn bg-white rounded-2 mx-lg-3 mx-xl-3 mx-0 "
                onClick={handleCheckin}
              >
                Check in
              </button>
            ) : (
              <button
                className="btn bg-white rounded-2 mx-lg-3 mx-xl-3 mx-0 "
                onClick={() => setShowMoadal(true)}
              >
                Check out
              </button>
            )}
          </div>

          <div className="col-auto mx-lg-3 mx-xl-3 px-0  ms-lg-0 ms-xl-0 ms-1">
            <div
              className="position-relative d-flex  align-items-center "
              onClick={handleDropdown}
              style={{ cursor: "pointer" }}
            >
              <Link
                className=" d-lg-inline  object-fit-contain   "
                style={{ height: "40px", width: "40px", borderRadius: "50%" }}
              >
                <img
                  src={`https://crm.propcasa.com/${userProfile}`}
                  alt="Profile"
                  onError={(e) => {
                    e.target.src = avatar;
                  }}
                  className="   object-fit-cover "
                  width={35}
                  height={35}
                  style={{ borderRadius: "50%" }}
                />
              </Link>
              <span className=" fw-medium d-none  d-lg-block  d-md-block  d-xl-block ">
                {" "}
                {userName && userName?.split(" ")[0]}
              </span>
            </div>
            {showDropdown && (
              <ul className=" bg-white  position-absolute top-100  end-0 px-4 py-3 rounded-1 shadow z-3   ">
                <li>
                  <Link to="/profile" className="pb-0 text-black text-center ">
                    {userName && userName?.split(" ")[0]} / {mobile && mobile}
                  </Link>
                </li>
                <hr className="my-2" />
                <li className="mb-1 bg-danger-subtle  rounded-1">
                  <Link to="/profile" className="p-2 text-black">
                    <i className="me-1 fa-solid fa-circle-user text-danger "></i>
                    Profile
                  </Link>
                </li>
                <li className="mb-1 bg-danger-subtle  rounded-1">
                  <Link to="/password" className="p-2 text-black">
                    <i className="me-1 fa-solid fa-lock text-danger"></i>Change
                    Password
                  </Link>
                </li>
                <li className="mb-1 bg-danger-subtle  rounded-1 ">
                  <Link
                    className="p-2 text-black "
                    onClick={handleLogout}
                  >
                    <i className="me-1 fa-solid fa-right-from-bracket text-danger"></i>
                    Logout
                  </Link>
                </li>
              </ul>
            )}
          </div>
        </div>
      </div>
      {showModal && (
        <CheckoutModal
          title={"Are you sure you want to Checkout"}
          handleCheckOut={handleCheckOut}
          setShowMoadal={setShowMoadal}
        />
      )}
    </>
  );
};

export default Navbar;
